export const SURVEY_PHRASES = {
    LOCATION: 16054,
    LENGTH: 1474,
    MINUTES: 2749,
    COMPENSATION: 1482,
    START_SURVEY: 1489,
    TELEPHONE_INTERVIEW: 3146,
    IN_PERSON_INTERVIEW: 3147,
    ONLINE: 2751,
    UP_TO: 3664,
    NEW_INCENTIVE: 4702,
    QUICK_STUDY: 4707,
    NEW_STUDY: 4701,
    FEW_SPACES: 4708,
    CURRENT_OPPORTUNITIES: 16058,
    PAST_PARTICIPATIONS: 16059,
    SELECT_YEAR: 16060,
    SEARCH: 16061,
    STATUS: 3567,
    PAYMENT: 1484,
    NEW_COMPENSATION: 4702,
    TRY_AGAIN: 4703,
    MOBILE_FRIENDLY: 4704,
    CLOSING_SOON: 4705,
    PAID_SCREEN_OUT: 4706,
    PATIENT_CHART: 4709,
    REAL_WORLD_EVIDENCE: 18807,
    STUDY_SEEN_FOR_FIRST_TIME: 16151,
    STUDY_COMPENSATION_INCREASED: 4710,
    STUDY_TECHNICAL_ISSUE_FIXED: 4711,
    STUDY_COMPLETED_ON_PHONE: 4712,
    STUDY_DEADLINE_APPROACHING: 4713,
    STUDY_COMPENSATION_FOR_NON_QUALIFICATION: 4714,
    STUDY_UNDER_FIVE_MINS: 4715,
    STUDY_LIMITED_SPACES: 4716,
    STUDY_REQUIRES_PATIENT_FORMS: 4717,
    STUDY_COLLECTION_FOR_REAL_WORLD: 18808,
    FILTER: 16064,
    NO_ITEMS: 2745,
    APPLY: 13022,
} as const;

export const SURVEY_HISTORY_PHRASES = {
    PROJECT_NUMBER: 16052,
    TOPIC: 2750,
    INVITE_CODE: 16051,
    LENGTH: 1474,
    STATUS: 3567,
    DATE: 1217,
    COMPENSATION: 1482,
    PAYMENT: 1484,
    TOTAL: 16053,
    COMPENSATION_EARNED: 1488,
    NO_COMPENSATION_TEXT: 3640,
    NO_COMPENSATION_TOOLTIP: 3641,
    NO_DATA_MESSAGE: 1485,
    MIN: 4729,
} as const;

export const SURVEY_STATUS_PHRASES = {
    STARTED: 1479,
    PARTIAL: 1656,
    COMPLETED: 16063,
    SCREENED_OUT: 1477,
    OVER_QUOTA: 1478,
} as const;

export const SURVEY_PAYMENT_PHRASES = {
    WALLET: 15966,
    BANK_TRANSFER: 1491,
    PAYPAL: 1492,
} as const;

export const SURVEY_TIMEOUT_PHRASES = {
    TIMED_OUT: 3590,
    INACTIVE_TOO_LONG: 3591,
    RESUME: 3593,
    WHAT_HAPPENED_CAN_I_RESUME: 3592,
    NO_RECORD_IN_SYSTEM: 1345,
} as const;
